import { render, staticRenderFns } from "./documents-template-entry.vue?vue&type=template&id=8de85a06"
import script from "./documents-template-entry.vue?vue&type=script&lang=js"
export * from "./documents-template-entry.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports